import { NGROK } from "../../../../APIs";
import { apiClient } from "../../../../utils/apiClient";

export interface TenantSmtpConfiguration {
    tenantName?: string;
    host: string;
    port: number;
    username?: string;
    hasPassword?: boolean;
    fromEmail: string;
    fromDisplayName?: string;
    useTls: boolean;
    useSsl: boolean;
    enabled: boolean;
    updatedAt?: string;
}

export interface TenantSmtpConfigurationRequest {
    host: string;
    port: number;
    username?: string;
    password?: string;
    fromEmail: string;
    fromDisplayName?: string;
    useTls: boolean;
    useSsl: boolean;
    enabled: boolean;
}

export const fetchSmtpConfiguration = async (tenantName: string): Promise<TenantSmtpConfiguration> => {
    const url = `${NGROK}/api/${encodeURIComponent(tenantName)}/smtp-configuration`;
    return apiClient<TenantSmtpConfiguration>({
        method: "GET",
        url,
    });
};

export const saveSmtpConfiguration = async (
    tenantName: string,
    payload: TenantSmtpConfigurationRequest,
): Promise<TenantSmtpConfiguration> => {
    const url = `${NGROK}/api/${encodeURIComponent(tenantName)}/smtp-configuration`;
    return apiClient<TenantSmtpConfiguration>({
        method: "POST",
        url,
        data: payload,
    });
};

export const deleteSmtpConfiguration = async (tenantName: string): Promise<boolean> => {
    const url = `${NGROK}/api/${encodeURIComponent(tenantName)}/smtp-configuration`;
    return apiClient<boolean>({
        method: "DELETE",
        url,
    });
};

export const sendSmtpTestEmail = async (tenantName: string, recipientEmail: string): Promise<boolean> => {
    const url = `${NGROK}/api/${encodeURIComponent(tenantName)}/smtp-configuration/test?recipientEmail=${encodeURIComponent(recipientEmail)}`;
    return apiClient<boolean>({
        method: "POST",
        url,
    });
};
